var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCalendar = function SvgCircleCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#DAFDD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle_calendar_svg__a)",
    fill: "#233E20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.089 11.222v.3H33.967a3.68 3.68 0 0 1 3.678 3.678v19.822a3.68 3.68 0 0 1-3.678 3.678H13.034a3.68 3.68 0 0 1-3.678-3.678V15.2a3.68 3.68 0 0 1 3.678-3.678h1.877V10.112c0-.446.366-.812.811-.812.446 0 .812.366.812.811v1.411H30.467V10.112c0-.446.365-.812.81-.812.446 0 .812.366.812.811v1.111Zm-17.178 2.223v-.3H13.033a2.06 2.06 0 0 0-2.055 2.055v3.545h25.044V15.2a2.06 2.06 0 0 0-2.055-2.055H32.089V14.555a.814.814 0 0 1-.811.812.814.814 0 0 1-.811-.812V13.146H16.533V14.555a.814.814 0 0 1-.81.812.814.814 0 0 1-.812-.812v-1.11Zm-3.633 6.922h-.3V35.022a2.06 2.06 0 0 0 2.056 2.056h20.933a2.06 2.06 0 0 0 2.055-2.056V20.367H11.278Z",
    stroke: "#DAFDD7",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.479 34h-1.875c0-1.17.115-2.2.345-3.09.24-.89.55-1.665.93-2.325.38-.67.785-1.25 1.215-1.74.43-.5.845-.945 1.245-1.335h-5.265v-1.56h6.855v1.74c-.5.49-.96 1.005-1.38 1.545a9.69 9.69 0 0 0-1.095 1.785c-.31.64-.55 1.37-.72 2.19-.17.81-.255 1.74-.255 2.79Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle_calendar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.5 9)",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgCircleCalendar;